import { render, staticRenderFns } from "./comp_CollectionEventIcon.vue?vue&type=template&id=d7179bae"
import script from "./comp_CollectionEventIcon.vue?vue&type=script&lang=js"
export * from "./comp_CollectionEventIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports